import { NewsWidget } from '@/core/widgets/model/news-widget';
import { NewsWidgetFactory } from '@/core/widgets/model/news-widget-factory';

// Ids that used to be registered here but have since moved elsewhere (e.g.
// bookmarks moved into the side panel under a new id). Consumers resolving
// saved layout/preference ids against the registry should skip these instead
// of treating a lookup miss as "widget still exists but somehow unresolvable".
export const STALE_WIDGET_IDS: string[] = ['/bookmarks'];

export interface WidgetRegistry {
  register(widget: NewsWidget): void;
  registerFactory(factory: NewsWidgetFactory): void;
  // Static instances only — dynamically created factory widgets are not
  // included here and must be resolved via getById() or enumerated via
  // getFactories().
  getAll(): NewsWidget[];
  getFactories(): NewsWidgetFactory[];
  getById(id: string): NewsWidget | undefined;
}

function createWidgetRegistry(): WidgetRegistry {
  const widgets = new Map<string, NewsWidget>();
  const factories: NewsWidgetFactory[] = [];

  return {
    register(widget) {
      widgets.set(widget.id, widget);
    },
    registerFactory(factory) {
      factories.push(factory);
    },
    getAll() {
      return Array.from(widgets.values());
    },
    getFactories() {
      return factories;
    },
    getById(id) {
      const template = factories.find(factory => factory.matchesTemplate(id));
      if (template) return template.createInstance(id);

      return widgets.get(id);
    },
  };
}

// One instance per surface — callers import the registry for the surface
// they need.
export const dashboardWidgetRegistry = createWidgetRegistry();
export const tabsWidgetRegistry = createWidgetRegistry();
